import { AutoRegisterClass } from 'src/app/services/generics/classRegistry';
import { Moeda } from './../financeiro/moeda';
import { Padrao } from '../generic/padrao';
import { Funcionario } from '../pessoa/funcionario';

@AutoRegisterClass()
export class FatorMoeda extends Padrao{

    override idTab = 4;

    moeda: Moeda = new Moeda();
    funcionario: Funcionario = new Funcionario();
    fator: number;
    dataHora: Date;
}
